



import Page from '../PostSales/sale/teskManage.vue'
export default {
  name: 'teskManageOEM',
  components: { Page },
}
